import React, { useState, useEffect } from "react";
import axios from "axios"; 
import "./LegendaUsers.css";

const Legenda = () => {
    const [markers, setMarkers] = useState([]);

    useEffect(() => {
        const loadMarkers = async () => {
            const cachedMarkers = localStorage.getItem("markers");
            if (cachedMarkers) {
                setMarkers(JSON.parse(cachedMarkers));
                return;
            }

            try {
                const response = await axios.get(route("building-markers"));
                if (response.status === 200) {
                    setMarkers(response.data);
                }
            } catch (error) {
                console.error("Erro ao carregar marcadores:", error);
            }
        };

        loadMarkers();
    }, []); 

    return (
        <div className="legenda-container">
            <h4 className="legenda-title">Empreendimentos</h4>

            {markers.length === 0 ? (
                <p className="p-3 text-muted text-center">Nenhum empreendimento encontrado.</p>
            ) : (
                <ul className="legenda-list">
                    {markers.map((marker, index) => {
                        const uniqueKey = marker.id || `${marker.tipo}-${marker.status}-${index}`;
                        
                        return (
                            <li className="legenda-item" key={uniqueKey}>
                                <div className="legenda-icon">
                                    <img src={marker.icon} alt={marker.tipo} />
                                </div>
                                <span className="legenda-text">
                                    {marker.tipo} {marker.padrao} {marker.status}
                                </span>
                            </li>
                        );
                    })}
                </ul>
            )}
        </div>
    );
};

export default Legenda;